// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Lens_Iso = require("../Data.Lens.Iso/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Constraint = function (x) {
    return x;
};
var ConstraintSet = function (x) {
    return x;
};
var semigroupConstraintSet = Data_List_Types.semigroupList;
var newtypeConstraint = new Data_Newtype.Newtype(function (n) {
    return n;
}, Constraint);
var monoidConstraintSet = Data_List_Types.monoidList;
var eqConstraint = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(dictEq)(x.source)(y.source) && Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(x.typeLeft)(y.typeLeft) && Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(x.typeRight)(y.typeRight);
        };
    });
};
var eqConstraintSet = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(Data_List_Types.eqList(eqConstraint(dictEq)))(x)(y);
        };
    });
};
var _typeRight = function (dictStrong) {
    var $24 = Data_Lens_Iso.iso(Data_Newtype.unwrap(newtypeConstraint))(Data_Newtype.wrap(newtypeConstraint))(dictStrong.Profunctor0());
    var $25 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "typeRight";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($26) {
        return $24($25($26));
    };
};
var _typeLeft = function (dictStrong) {
    var $27 = Data_Lens_Iso.iso(Data_Newtype.unwrap(newtypeConstraint))(Data_Newtype.wrap(newtypeConstraint))(dictStrong.Profunctor0());
    var $28 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "typeLeft";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($29) {
        return $27($28($29));
    };
};
var substiuableConstraint = new Lunarbox_Data_Dataflow_Class_Substituable.Substituable(function (substitution) {
    var applySubstitution = Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(substitution);
    var $30 = Data_Lens_Setter.over(_typeLeft(Data_Profunctor_Strong.strongFn))(applySubstitution);
    var $31 = Data_Lens_Setter.over(_typeRight(Data_Profunctor_Strong.strongFn))(applySubstitution);
    return function ($32) {
        return $30($31($32));
    };
}, function (v) {
    return Data_Set.union(Lunarbox_Data_Dataflow_Type.ordTVarName)(Lunarbox_Data_Dataflow_Class_Substituable.ftv(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(v.typeLeft))(Lunarbox_Data_Dataflow_Class_Substituable.ftv(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(v.typeRight));
});
var _source = function (dictStrong) {
    var $33 = Data_Lens_Iso.iso(Data_Newtype.unwrap(newtypeConstraint))(Data_Newtype.wrap(newtypeConstraint))(dictStrong.Profunctor0());
    var $34 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "source";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($35) {
        return $33($34($35));
    };
};
module.exports = {
    Constraint: Constraint,
    ConstraintSet: ConstraintSet,
    "_typeLeft": _typeLeft,
    "_typeRight": _typeRight,
    "_source": _source,
    eqConstraint: eqConstraint,
    newtypeConstraint: newtypeConstraint,
    substiuableConstraint: substiuableConstraint,
    eqConstraintSet: eqConstraintSet,
    semigroupConstraintSet: semigroupConstraintSet,
    monoidConstraintSet: monoidConstraintSet
};
